// src/app/core/feature-flags/feature-flag.service.ts
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../config/config.service';
import type { RuntimeConfig } from '../config/runtime-config.model';

/**
 * FeatureFlagService — habilita/deshabilita módulos desde runtime-config.json.
 *
 * Uso en rutas:
 *   canActivate: [authGuard, () => inject(FeatureFlagService).isEnabled('savingsModule')]
 *
 * Uso en templates:
 *   @if (featureFlags.isEnabled('exportCsv')) { ... }
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly config = inject(ConfigService);

  /**
   * Retorna true si el feature está habilitado en runtime-config.json.
   * Type-safe: el compilador verifica que el flag exista en features{}.
   */
  isEnabled(flag: keyof RuntimeConfig['features']): boolean {
    return this.config.get('features')[flag];
  }
}
